<div class="At-MessagePage">

  <button class="At-AddBtn" (click)="openModal(template)"><i class="icon-add"></i></button>

  <!-- Messages SideBar Start  -->
  <aside class="At-Sidebar At-ListSideBar">
    <div class="At-PageTitle">
      <h2>Messages</h2>
    </div>
    <form class="At-search">
      <fieldset>
        <div class="At-InputWithIcon">
          <input type="search" class="form-control" placeholder="Search ...">
          <i class="icon-search"></i>
        </div>
      </fieldset>
    </form>
    <div class="At-MessagesList-Box">
      <div class="At-TabsArea">
        <tabset>
          <tab heading="All Messages" id="tab1">
            <div class="At-TabContent">
              <ul class="At-MessageList At-CustomScroll">
                <li class="active">
                  <div class="At-InfoBox">
                    <div class="At-InfoImg">
                      <figure>
                        <img src="assets/images/members/member-img01.png" alt="">
                        <div class="At-badgePurple">
                          <i class="icon-bage"></i>
                        </div>
                      </figure>
                    </div>
                    <div class="At-InfoTitle d-flex">
                      <div class="At-TitleLeft">
                        <h5>Julian . <span class="At-TextRed">jona </span> . <span class="At-TextRed">coo</span></h5>
                        <h6>Let’s wrap this up quick guys.</h6>
                      </div>
                      <div class="At-TitleRight">
                        <span class="At-Time">10:12</span>
                        <span class="At-Count">1</span>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="At-InfoBox">
                    <div class="At-InfoImg">
                      <figure>
                        <img src="assets/images/members/member-img02.png" alt="" class="img-fluid">
                      </figure>
                    </div>
                    <div class="At-InfoTitle d-flex">
                      <div class="At-TitleLeft">
                        <h5>Micheal Decosta . <span>mikkie</span></h5>
                        <h6>I have finished the report and will share here in few minutes</h6>
                      </div>
                      <div class="At-TitleRight">
                        <span class="At-Time">10:12</span>
                        <span class="At-Count">2</span>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="At-InfoBox">
                    <div class="At-InfoImg">
                      <figure>
                        <img src="assets/images/members/member-img04.png" alt="">
                      </figure>
                    </div>
                    <div class="At-InfoTitle d-flex">
                      <div class="At-TitleLeft">
                        <h5>Softpetal:) . <span>floralqueen</span></h5>
                        <h6>joined this channel “general meetings”</h6>
                      </div>
                      <div class="At-TitleRight">
                        <span class="At-Time">10:12</span>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="At-InfoBox">
                    <div class="At-InfoImg">
                      <figure>
                        <img src="assets/images/members/member-img01.png" alt="">
                        <div class="At-badgePurple">
                          <i class="icon-bage"></i>
                        </div>
                      </figure>
                    </div>
                    <div class="At-InfoTitle d-flex">
                      <div class="At-TitleLeft">
                        <h5>Julian . <span class="At-TextRed">jona </span> . <span class="At-TextRed">coo</span></h5>
                        <h6>Let’s wrap this up quick guys.</h6>
                      </div>
                      <div class="At-TitleRight">
                        <span class="At-Time">10:12</span>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="At-InfoBox">
                    <div class="At-InfoImg">
                      <figure>
                        <img src="assets/images/members/member-img02.png" alt="" class="img-fluid">
                      </figure>
                    </div>
                    <div class="At-InfoTitle d-flex">
                      <div class="At-TitleLeft">
                        <h5>Micheal Decosta . <span>mikkie</span></h5>
                        <h6>We are proud to annouce that our last project was successful and we might we give out bonuses to our employees who worked
                          so hard for this project.Congras!!!</h6>
                      </div>
                      <div class="At-TitleRight">
                        <span class="At-Time">10:12</span>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="At-InfoBox">
                    <div class="At-InfoImg">
                      <figure>
                        <img src="assets/images/members/member-img04.png" alt="">
                      </figure>
                    </div>
                    <div class="At-InfoTitle d-flex">
                      <div class="At-TitleLeft">
                        <h5>Softpetal:) . <span>floralqueen</span></h5>
                        <h6>Party ....we need party boss</h6>
                      </div>
                      <div class="At-TitleRight">
                        <span class="At-Time">10:12</span>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="At-InfoBox">
                    <div class="At-InfoImg">
                      <figure>
                        <img src="assets/images/members/member-img03.png" alt="">
                      </figure>
                    </div>
                    <div class="At-InfoTitle d-flex">
                      <div class="At-TitleLeft">
                        <h5>Jacob . <span>jazzy</span></h5>
                        <h6>yes ... yes .. party!!</h6>
                      </div>
                      <div class="At-TitleRight">
                        <span class="At-Time">10:12</span>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="At-InfoBox">
                    <div class="At-InfoImg">
                      <figure>
                        <img src="assets/images/members/member-img02.png" alt="" class="img-fluid">
                      </figure>
                    </div>
                    <div class="At-InfoTitle d-flex">
                      <div class="At-TitleLeft">
                        <h5>Micheal Decosta . <span>mikkie</span></h5>
                        <h6>yes why not.<br>
                          what say Julian?</h6>
                      </div>
                      <div class="At-TitleRight">
                        <span class="At-Time">10:12</span>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="At-InfoBox">
                    <div class="At-InfoImg">
                      <figure>
                        <img src="assets/images/members/member-img01.png" alt="">
                        <div class="At-badgePurple">
                          <i class="icon-bage"></i>
                        </div>
                      </figure>
                    </div>
                    <div class="At-InfoTitle d-flex">
                      <div class="At-TitleLeft">
                        <h5>Julian . <span class="At-TextRed">jona </span> . <span class="At-TextRed">coo</span></h5>
                        <h6>Sure, why not. Lets keeo in mind this saturday. I will talk to the upper management.</h6>
                      </div>
                      <div class="At-TitleRight">
                        <span class="At-Time">10:12</span>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </tab>
          <tab heading="Secret Messages">
            <div class="At-TabContent">
              <ul class="At-MessageList At-CustomScroll">
                <li>
                  <div class="At-InfoBox">
                    <div class="At-InfoImg">
                      <figure>
                        <img src="assets/images/members/member-img04.png" alt="">
                        <div class="At-badgePurple At-Lock">
                          <i class="icon-lock-1"></i>
                        </div>
                      </figure>
                    </div>
                    <div class="At-InfoTitle d-flex">
                      <div class="At-TitleLeft">
                        <h5>Softpetal:) . <span>floralqueen</span></h5>
                        <h6>Party ....we need party boss</h6>
                      </div>
                      <div class="At-TitleRight">
                        <span class="At-Time">10:12</span>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="At-InfoBox">
                    <div class="At-InfoImg">
                      <figure>
                        <img src="assets/images/members/member-img03.png" alt="">
                        <div class="At-badgePurple At-Lock">
                          <i class="icon-lock-1"></i>
                        </div>
                      </figure>
                    </div>
                    <div class="At-InfoTitle d-flex">
                      <div class="At-TitleLeft">
                        <h5>Jacob . <span>jazzy</span></h5>
                        <h6>yes ... yes .. party!!</h6>
                      </div>
                      <div class="At-TitleRight">
                        <span class="At-Time">10:12</span>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="At-InfoBox">
                    <div class="At-InfoImg">
                      <figure>
                        <img src="assets/images/members/member-img01.png" alt="">
                        <div class="At-badgePurple">
                          <i class="icon-bage"></i>
                        </div>
                        <div class="At-badgePurple At-Lock">
                          <i class="icon-lock-1"></i>
                        </div>
                      </figure>
                    </div>
                    <div class="At-InfoTitle d-flex">
                      <div class="At-TitleLeft">
                        <h5>Julian . <span class="At-TextRed">jona </span> . <span class="At-TextRed">coo</span></h5>
                        <h6>Sure, why not. Lets keeo in mind this saturday. I will talk to the upper management.</h6>
                      </div>
                      <div class="At-TitleRight">
                        <span class="At-Time">10:12</span>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="At-InfoBox">
                    <div class="At-InfoImg">
                      <figure>
                        <img src="assets/images/members/member-img02.png" alt="" class="img-fluid">
                        <div class="At-badgePurple At-Lock">
                          <i class="icon-lock-1"></i>
                        </div>
                      </figure>
                    </div>
                    <div class="At-InfoTitle d-flex">
                      <div class="At-TitleLeft">
                        <h5>Micheal Decosta . <span>mikkie</span></h5>
                        <h6>yes why not.<br>
                          what say Julian?</h6>
                      </div>
                      <div class="At-TitleRight">
                        <span class="At-Time">10:12</span>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </tab>
        </tabset>
      </div>
    </div>
  </aside>
  <!-- Messages SideBar ends  -->

  <!-- Messages Content Start  -->
  <div class="At-ChatContent-area">
    <div class="At-ChatHeader">
      <div class="At-InfoBox">
        <div class="At-InfoImg">
          <figure>
            <img src="assets/images/members/member-img01.png" alt="">
            <div class="At-badgePurple">
              <i class="icon-bage"></i>
            </div>
          </figure>
        </div>
        <div class="At-InfoTitle d-flex">
          <div class="At-TitleLeft">
            <h5>Julian . <span class="At-TextRed">jona </span> . <span class="At-TextRed">coo</span></h5>
            <h6><i class="circal"></i> Active Now</h6>
          </div>
        </div>
      </div>
      <ul class="At-ActionBtns">
        <li><a href="javascript:void(0);" class="At-SquareIcon" routerLink="/audio-call"><i class="icon-phone"></i></a></li>
        <li><a href="javascript:void(0);" class="At-SquareIcon" routerLink="/video-call"><i class="icon-video-camera"></i></a></li>
        <li><a href="javascript:void(0);" class="At-SquareIcon"><i class="icon-copy"></i></a></li>
        <li>
          <div class="btn-group At-DropdownBox" dropdown>
            <button id="button-basic" dropdownToggle type="button" class="dropdown-toggle" aria-controls="dropdown-basic"><i class="icon-profile"></i> <i class="icon-down-arrow"></i></button>
            <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-basic">
              <li role="menuitem"><a href="javascript:void(0);" (click)="toggleShowProfile()"> <i class="icon-profile"></i> view profile</a></li>
              <li role="menuitem"><a href="javascript:void(0);"> <i class="icon-clear-chat"></i> clear chat</a></li>
              <li role="menuitem"><a href="javascript:void(0);"> <i class="icon-user-add"></i> add / remove contact</a></li>
              <li role="menuitem"><a href="javascript:void(0);"> <i class="icon-mute-notification"></i> mute notifications</a></li>
              <li role="menuitem" class="At-Footerbtns">
                <button type="button" class="At-Report">report</button>
                <button type="button" class="At-Block">Block</button>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
    <div class="At-ChatContent">
      <div class="At-MessageBox">
        <div class="At-InfoImg">
          <figure>
            <img src="assets/images/members/member-img01.png" alt="">
            <div class="At-badgePurple">
              <i class="icon-bage"></i>
            </div>
          </figure>
        </div>
        <div class="At-MessageText">
          <p>Come back soon sweetie. I am really missing you.</p>
        </div>
        <span class="At-Time">12:09</span>
        <div class="btn-group At-DropdownBox" dropdown>
          <button id="button-basic1" dropdownToggle type="button" class="At-dropdownBtn dropdown-toggle" aria-controls="dropdown-basic1"><i class="icon-more"></i></button>
          <ul id="dropdown-basic1" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-basic1">
            <li role="menuitem"><a href="javascript:void(0);" routerLink="/dashboard/profile"> <i class="icon-edit"></i> edit</a></li>
            <li role="menuitem"><a href="javascript:void(0);"> <i class="icon-copy"></i> copy</a></li>
            <li role="menuitem"><a href="javascript:void(0);"> <i class="icon-quote"></i> quote</a></li>
            <li role="menuitem"><a href="javascript:void(0);"> <i class="icon-forward"></i> forward</a></li>
            <li role="menuitem"><a href="javascript:void(0);"> <i class="icon-pin"></i> pin message</a></li>
            <li role="menuitem"><a href="javascript:void(0);"> <i class="icon-cancel"></i> remove</a></li>
          </ul>
        </div>
      </div>
      <div class="At-DateBar">
        <span>Today</span>
      </div>
      <div class="At-MessageBox At-RightBox">
        <div class="At-MessageText">
          <p>Ohh, miss you too hon</p>
        </div>
        <span class="At-Time">12:09</span>
        <div class="btn-group" dropdown>
          <button id="button-basic" dropdownToggle type="button" class="At-dropdownBtn dropdown-toggle" aria-controls="dropdown-basic">
            <i class="icon-more"></i>
          </button>
        </div>
      </div>
      <div class="At-MessageBox At-RightBox">
        <div class="At-MessageText">
          <p>Check out this place i visit today</p>
          <figure>
            <img src="assets/images/chat-image.jpg" alt="Image">
          </figure>
        </div>
        <span class="At-Time">12:09</span>
        <div class="btn-group" dropdown>
          <button id="button-basic" dropdownToggle type="button" class="At-dropdownBtn dropdown-toggle" aria-controls="dropdown-basic">
            <i class="icon-more"></i>
          </button>
        </div>
      </div>
      <div class="At-MessageBox">
        <div class="At-InfoImg">
          <figure>
            <img src="assets/images/members/member-img01.png" alt="">
            <div class="At-badgePurple">
              <i class="icon-bage"></i>
            </div>
          </figure>
        </div>
        <div class="At-MessageText">
          <p>Awsommee <span class="At-imprationicon"><img src="assets/images/heart-img.png" alt="image"></span></p>
        </div>
        <span class="At-Time">12:09</span>
        <div class="btn-group" dropdown>
          <button id="button-basic" dropdownToggle type="button" class="At-dropdownBtn dropdown-toggle" aria-controls="dropdown-basic">
            <i class="icon-more"></i>
          </button>
        </div>
      </div>
      <div class="At-MessageBox">
        <div class="At-InfoImg">
          <figure></figure>
        </div>
        <div class="At-MessageText">
          <div class="At-Audiobox">
            <button class="At-PauseBtn"><i class="icon-pause"></i></button><span class="At-Time">01:15</span><span class="At-AudioImage"><img src="assets/images/audio.png" alt="Image"></span>
          </div>
        </div>
        <span class="At-Time">12:09</span>
        <div class="btn-group" dropdown>
          <button id="button-basic" dropdownToggle type="button" class="At-dropdownBtn dropdown-toggle" aria-controls="dropdown-basic">
            <i class="icon-more"></i>
          </button>
        </div>
      </div>
      <div class="At-MessageBox At-RightBox">
        <div class="At-MessageText">
          <p>Don’t worry i haven’t forget your list <span class="At-imprationicon"><img src="assets/images/smiley-img.png" alt="Image"></span></p>
        </div>
        <span class="At-Time">12:09</span>
        <div class="btn-group" dropdown>
          <button id="button-basic" dropdownToggle type="button" class="At-dropdownBtn dropdown-toggle" aria-controls="dropdown-basic">
            <i class="icon-more"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="At-ChatFooter">
      <div class="At-TextAndActions">
        <button type="button" class="At-ImprestionBtn"><i class="icon-face-emoji"></i></button>
        <input type="text" class="form-control" placeholder="Say something ...">
        <button type="button" class="At-AttchmentBtn"><i class="icon-attachment"></i></button>
        <button type="button" class="At-SendBtn"><i class="icon-send-1"></i></button>
      </div>
      <button type="button" class="At-VoiceBtn"><i class="icon-mike"></i></button>
    </div>
  </div>
  <!-- Messages Content End  -->

  <!-- User Profile Information Start  -->
  <div class="At-ProfileSidebarHolder" *ngIf="isProfile">
    <app-activity-post (onClose)="closeShare()"></app-activity-post>
  </div>
  <!-- User Profile Information End  -->

</div>
<!-- New Messages Modal Start  -->

<ng-template #template>
  <div class="modal-header border-0 d-flex align-items-center">
    <h3 class="modal-title pull-left">New Message</h3>
    <button type="button" class="close At-ModalClose" aria-label="Close" (click)="modalRef.hide()">
      <i class="icon-cancel"></i>
    </button>
  </div>
  <div class="At-ModalBody">
    <div class="modal-bodyContent">
      <form class="At-UserSearch">
        <div class="form-group">
          <label>To</label>
          <input type="text" class="form-control">
        </div>
      </form>
      <div class="At-UsersBox">
        <div class="At-Heading">
          <h4>recent</h4>
        </div>
        <ul class="At-UserList">
          <li>
            <div class="At-InfoImg">
              <figure>
                <img src="assets/images/members/member-img01.png" alt="Usre Image">
              </figure>
            </div>
            <span>Aiman</span>
          </li>
          <li>
            <div class="At-InfoImg">
              <figure>
                <img src="assets/images/members/member-img02.png" alt="Usre Image">
              </figure>
            </div>
            <span>miche..</span>
          </li>
          <li>
            <div class="At-InfoImg">
              <figure>
                <img src="assets/images/members/member-img03.png" alt="Usre Image">
              </figure>
            </div>
            <span>jacob..</span>
          </li>
          <li>
            <div class="At-InfoImg">
              <figure>
                <img src="assets/images/members/member-img04.png" alt="Usre Image">
              </figure>
            </div>
            <span>softpe..</span>
          </li>
          <li>
            <div class="At-InfoImg">
              <figure>
                <img src="assets/images/members/member-img05.png" alt="Usre Image">
              </figure>
            </div>
            <span>Anita</span>
          </li>
          <li>
            <div class="At-InfoImg">
              <figure>
                <img src="assets/images/members/member-img06.png" alt="Usre Image">
              </figure>
            </div>
            <span>Aiman</span>
          </li>
        </ul>
      </div>
      <div class="At-UsersBox">
        <div class="At-Heading">
          <h4>All</h4>
        </div>
        <ul class="At-UsersBoxHolder At-CustomScroll">
          <li class="active">
            <div class="At-InfoBox">
              <div class="At-InfoImg">
                <figure>
                  <img src="assets/images/members/member-img01.png" alt="">
                  <div class="At-badgePurple">
                    <i class="icon-bage"></i>
                  </div>
                </figure>
              </div>
              <div class="At-InfoTitle d-flex">
                <div class="At-TitleLeft">
                  <h5>Julian . <span class="At-TextRed">jona </span> . <span class="At-TextRed">coo</span></h5>
                  <h6>Last seen 5 minte ago</h6>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="At-InfoBox">
              <div class="At-InfoImg">
                <figure>
                  <img src="assets/images/members/member-img02.png" alt="" class="img-fluid">
                </figure>
              </div>
              <div class="At-InfoTitle d-flex">
                <div class="At-TitleLeft">
                  <h5>Micheal Decosta . <span>mikkie</span></h5>
                  <h6>Last seen 5 minte ago</h6>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="At-InfoBox">
              <div class="At-InfoImg">
                <figure>
                  <img src="assets/images/members/member-img04.png" alt="">
                </figure>
              </div>
              <div class="At-InfoTitle d-flex">
                <div class="At-TitleLeft">
                  <h5>Softpetal:) . <span>floralqueen</span></h5>
                  <h6>Last seen 5 minte ago</h6>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="At-InfoBox">
              <div class="At-InfoImg">
                <figure>
                  <img src="assets/images/members/member-img01.png" alt="">
                  <div class="At-badgePurple">
                    <i class="icon-bage"></i>
                  </div>
                </figure>
              </div>
              <div class="At-InfoTitle d-flex">
                <div class="At-TitleLeft">
                  <h5>Julian . <span class="At-TextRed">jona </span> . <span class="At-TextRed">coo</span></h5>
                  <h6>Last seen 5 minte ago</h6>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="At-InfoBox">
              <div class="At-InfoImg">
                <figure>
                  <img src="assets/images/members/member-img02.png" alt="" class="img-fluid">
                </figure>
              </div>
              <div class="At-InfoTitle d-flex">
                <div class="At-TitleLeft">
                  <h5>Micheal Decosta . <span>mikkie</span></h5>
                  <h6>Last seen 5 minte ago</h6>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="At-InfoBox">
              <div class="At-InfoImg">
                <figure>
                  <img src="assets/images/members/member-img04.png" alt="">
                </figure>
              </div>
              <div class="At-InfoTitle d-flex">
                <div class="At-TitleLeft">
                  <h5>Softpetal:) . <span>floralqueen</span></h5>
                  <h6>Last seen 5 minte ago</h6>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="At-InfoBox">
              <div class="At-InfoImg">
                <figure>
                  <img src="assets/images/members/member-img03.png" alt="">
                </figure>
              </div>
              <div class="At-InfoTitle d-flex">
                <div class="At-TitleLeft">
                  <h5>Jacob . <span>jazzy</span></h5>
                  <h6>Last seen 5 minte ago</h6>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="At-InfoBox">
              <div class="At-InfoImg">
                <figure>
                  <img src="assets/images/members/member-img02.png" alt="" class="img-fluid">
                </figure>
              </div>
              <div class="At-InfoTitle d-flex">
                <div class="At-TitleLeft">
                  <h5>Micheal Decosta . <span>mikkie</span></h5>
                  <h6>Last seen 5 minte ago</h6>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</ng-template>

<!-- New Messages Modal End  -->

